export default "__VITE_ASSET__BPPBi4WS__"